"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "createMachine", {
  enumerable: true,
  get: function () {
    return _createMachine.default;
  }
});
var _createMachine = _interopRequireDefault(require("./createMachine"));